import { queryFloatWindowInfo } from "@/api/market";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
// 浮标数据
export interface FloatWindowVO {
  jumpType: string;
  jumpTarget: string;
  imgUrl: string;
}

// 弹窗数据
export interface PopScreenVO {
  jumpType: string;
  jumpTarget: string;
  imgUrl: string;
}

export interface ResourceFloatData {
  floatWindowVO?: FloatWindowVO;
  popScreenVO?: PopScreenVO;
}
const mock = {
  data: {
    floatWindowVO: {
      jumpType: "LIVE",
      jumpTarget: "1443607289399246848",
      imgUrl:
        "https://akim-oss.aikucun.com/df9c775dca0c1fa7f3cab3f64b5459a4722361f9_1762325164368_41.png",
    },
    popScreenVO: {
      jumpType: "URL",
      jumpTarget: "http://192.168.215.215:4001/",
      //   jumpType: "CUSTOM_PAGE_30",
      //   jumpTarget: "1880152530604179458",
      //   jumpType: "ACTIVITY",
      //   jumpTarget: "1880152530604179458",
      //   jumpType: "PRODUCT",
      //   jumpTarget: "1940968554786652161",
      imgUrl:
        "https://akim-oss.aikucun.com/376f4d14ace66fd0eb5d64527dc8b791d94095a9_1762425086592_17.png",
    },
  },
};
/**
 * 资源位浮标和弹窗数据 Hook
 * @param location 页面位置标识
 * @param extraData 拓展参数，主要做埋点用
 * @returns data: 浮标和弹窗数据
 */
export function useResourceFloat(location: string, extraData?: any) {
  const [data, setData] = useState<ResourceFloatData>({});
  const [extraPopTrack, setExtraPopTrack] = useState<any>({});
  const [extraMovableTrack, setExtraMovableTrack] = useState<any>({});
  const [search] = useSearchParams();
  useEffect(() => {
    if (!location) {
      return;
    }

    const fetchData = async () => {
      try {
        const { activitySpuId, activityId } = extraData || {};
        if (location === "product_detail" && !activitySpuId) {
          return;
        }
        if (location === "activity_detail" && !activityId) {
          return;
        }
        const res = await queryFloatWindowInfo({ location, activitySpuId, activityId });
        // const res = mock;
        if (res?.data) {
          setData(res.data);
          buildTrackData(res.data);
        }
      } catch (error) {
        console.error("获取资源位浮窗数据失败:", error);
      }
    };
    // 拼接埋点参数
    const buildTrackData = res => {
      const { jumpType, jumpTarget } = res || {};
      let resource_content = "";
      switch (jumpType) {
        case "ACTIVITY":
          resource_content = "档期";
          break;
        case "PRODUCT":
          resource_content = "商详页 ";
          break;
        case "LIVE":
          resource_content = "直播间";
          break;
        case "CUSTOM_PAGE_30":
          resource_content = "会场3.0";
          break;
        case "CUSTOM_PAGE_MERCHANT_SHOP":
          resource_content = "店铺";
          break;
        case "URL":
          resource_content = "自定义链接";
          break;
        default:
          resource_content = "";
          break;
      }
      // 公共埋点参数
      const baseTrack = {
        config_source: "人工",
        live_no: jumpType === "LIVE" ? jumpTarget : undefined,
        custom_link_id: jumpType === "URL" ? jumpTarget : undefined,
        activity_spu_code: jumpType === "PRODUCT" ? jumpTarget : undefined,
        merchant_shop_code: jumpType === "CUSTOM_PAGE_MERCHANT_SHOP" ? jumpTarget : undefined,
        resource_content,
        page_name: document.title,
        previous_page_name: search.get("previous_page_name") || "",
      };
      console.log("baseTrack:", baseTrack);
      const { selectSkuId, activitySpuId, brandName, activityId } = extraData || {};
      let extraPopTrack = {}; // 弹窗埋点数据
      let extraMovableTrack = {}; // 浮标埋点数据
      switch (location) {
        case "index":
          extraPopTrack = {
            resource_name: "首页弹窗",
            module: "资源位-弹窗",
            page_name: "首页",
            tracking_plan_ids: {
              expose: "14804",
              click: "14806",
              close: "14805",
            },
          };
          extraMovableTrack = {
            resource_name: "首页浮窗",
            module: "资源位-浮窗",
            page_name: "首页",
            tracking_plan_ids: {
              expose: "14819",
              click: "14821",
              close: "14820",
            },
          };
          break;
        case "product_detail":
          extraPopTrack = {
            resource_name: "商详弹窗",
            module: "资源位-弹窗",
            page_name: "商详页",
            sku_id: selectSkuId,
            spu_id: activitySpuId,
            tracking_plan_ids: {
              expose: "14812",
              click: "14814",
              close: "14813",
            },
          };
          extraMovableTrack = {
            resource_name: "商详浮窗",
            module: "资源位-浮窗",
            page_name: "商详页",
            sku_id: selectSkuId,
            spu_id: activitySpuId,
            tracking_plan_ids: {
              expose: "14822",
              click: "14824",
              close: "14823",
            },
          };
          break;
        case "activity_detail":
          extraPopTrack = {
            resource_name: "档期页弹窗",
            module: "资源位-弹窗",
            page_name: "档期详情页",
            activity_name: brandName || "品牌活动",
            activity_id: activityId,
            tracking_plan_ids: {
              expose: "14807",
              click: "14809",
              close: "14808",
            },
          };
          extraMovableTrack = {
            resource_name: "档期页浮窗",
            module: "资源位-浮窗",
            page_name: "档期详情页",
            activity_name: brandName || "品牌活动",
            activity_id: activityId,
            tracking_plan_ids: {
              expose: "14825",
              click: "14826",
              close: "14827",
            },
          };
          break;
        case "pay_finish":
          extraPopTrack = {
            resource_name: "支付完成页弹窗",
            module: "资源位-弹窗",
            page_name: "支付完成页",
            tracking_plan_ids: {
              expose: "14815",
              click: "14817",
              close: "14816",
            },
          };
          break;
        case "my":
          extraMovableTrack = {
            resource_name: "我的页浮窗",
            module: "资源位-浮窗",
            page_name: "我的页面",
            tracking_plan_ids: {
              expose: "14828",
              click: "14830",
              close: "14829",
            },
          };
          break;
      }
      setExtraPopTrack({ ...baseTrack, ...extraPopTrack });
      setExtraMovableTrack({ ...baseTrack, ...extraMovableTrack });
    };

    fetchData();
  }, [location, extraData]);
  return { data, extraPopTrack, extraMovableTrack };
}

export default useResourceFloat;
